import React from "react";

const ReportCard = ({ title, value, subtitle, icon: Icon, color = "#0b6462" }) => {
  return (
    <div
      className="p-3 h-100"
      style={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span
          style={{
            fontSize: "11px",
            color: "#64748b",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {title}
        </span>
        {Icon && (
          <span style={{ color, opacity: 0.85 }}>
            <Icon size={18} />
          </span>
        )}
      </div>
      <h5 className="mt-2 mb-0" style={{ fontWeight: 700, color: "#0f172a", fontSize: "18px" }}>
        {value}
      </h5>
      {subtitle && (
        <small
          style={{
            color: "#94a3b8",
            fontSize: "11px",
            marginTop: "3px",
            display: "block",
          }}
        >
          {subtitle}
        </small>
      )}
    </div>
  );
};

export default ReportCard;
